(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avanza-landing-unificada"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.AvanzaLandingUnificada) { window.AvanzaLandingUnificada.init(document); return; }
  const instances = new Map();
  function setup(section) {
    if (instances.has(section)) return;
    const events = new AbortController();
    const campaign = section.dataset.campaign || section.id;
    const duration = Math.max(1000, Number(section.dataset.duration) || 900000);
    const key = `avanza:${campaign}`;
    const designMode = section.dataset.designMode === 'true';
    let deadline;
    // El editor usa una cuenta de prueba independiente de la oferta pública.
    if (!designMode) {
      try { deadline = Number.parseInt(localStorage.getItem(key) || '', 10); } catch { /* storage bloqueado */ }
    }
    if (!Number.isFinite(deadline)) {
      deadline = Date.now() + duration;
      if (!designMode) {
        try { localStorage.setItem(key, String(deadline)); } catch { /* sesión actual */ }
      }
    }
    const timer = section.querySelector('[data-avanza-timer]');
    const promoImage = section.querySelector('[data-avanza-promo]');
    const activeCopy = section.querySelectorAll('[data-active-only]');
    const expiredCopy = section.querySelectorAll('[data-expired-only]');
    const popup = section.querySelector('[data-avanza-popup]');
    const popupMessages = Array.from(section.querySelectorAll('[data-avanza-popup-message]'));
    const buttons = section.querySelectorAll('[data-avanza-purchase]');
    const bonusEnabled = section.dataset.bonusEnabled !== 'false';
    let active = bonusEnabled, busy = false, popupIndex = 0, popupTimeout, requestController;
    const render = () => {
      if (designMode && deadline <= Date.now()) deadline = Date.now() + duration;
      const remaining = Math.max(0, deadline - Date.now());
      active = bonusEnabled && remaining > 0;
      const seconds = Math.ceil(remaining / 1000);
      if (timer) timer.textContent = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
      section.classList.toggle('is-expired', !active);
      if (promoImage) promoImage.hidden = !active;
      activeCopy.forEach(el => { el.hidden = !active; });
      expiredCopy.forEach(el => { el.hidden = active; });
      if (!active && popup && popup.dataset.bonusVisible === 'true') popup.hidden = true;
    };
    render();
    const interval = window.setInterval(render, 1000);
    document.addEventListener('visibilitychange', render, { signal: events.signal });
    section.querySelectorAll('[data-avanza-faq]').forEach(button => button.addEventListener('click', () => {
      const answer = document.getElementById(button.getAttribute('aria-controls'));
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      const icon = button.querySelector('[aria-hidden]');
      if (icon) icon.textContent = expanded ? '+' : '−';
      if (answer) answer.hidden = expanded;
    }, { signal: events.signal }));
    const showMessage = text => section.querySelectorAll('[data-connection-message]').forEach(el => { el.textContent = text; el.hidden = false; });
    buttons.forEach(button => button.addEventListener('click', async () => {
      if (busy) return;
      const variantId = section.dataset.variantId || '';
      if (!/^\d+$/.test(variantId)) { showMessage(section.dataset.errorMissing || 'Selecciona el producto en el editor de Shopify para conectar la compra.'); return; }
      if (section.dataset.available !== 'true') { showMessage(section.dataset.errorUnavailable || 'Este producto no está disponible en este momento.'); return; }
      if (section.dataset.designMode === 'true') { showMessage(section.dataset.errorPreview || 'Comprueba la compra fuera del editor.'); return; }
      render();
      busy = true;
      buttons.forEach(el => { el.disabled = true; el.setAttribute('aria-busy', 'true'); });
      requestController = new AbortController();
      const rawRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || section.dataset.cartRoot || '/';
      const root = rawRoot.endsWith('/') ? rawRoot : `${rawRoot}/`;
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          signal: requestController.signal,
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _avanza_campaign: campaign, _avanza_deadline: String(deadline) } }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : (section.dataset.errorPurchase || 'No se pudo conectar con la compra.'));
        window.location.assign(`${root}checkout`);
      } catch (error) {
        if (error.name !== 'AbortError') showMessage(error.message || section.dataset.errorPurchase || 'No se pudo conectar con la compra.');
        busy = false;
        buttons.forEach(el => { el.disabled = false; el.removeAttribute('aria-busy'); });
      }
    }, { signal: events.signal }));
    const showPopup = () => {
      if (!popup || section.dataset.popupsEnabled === 'false') return;
      const eligible = popupMessages.filter(el => el.textContent.trim() && (active || el.dataset.bonusMessage !== 'true'));
      if (!eligible.length) return;
      const selected = eligible[popupIndex++ % eligible.length];
      popupMessages.forEach(el => { el.hidden = el !== selected; });
      popup.dataset.bonusVisible = String(selected.dataset.bonusMessage === 'true');
      popup.hidden = false;
      window.clearTimeout(popupTimeout);
      popupTimeout = window.setTimeout(() => { popup.hidden = true; }, 5000);
    };
    const popupInterval = window.setInterval(showPopup, 20000);
    const close = section.querySelector('[data-avanza-popup-close]');
    if (close) close.addEventListener('click', () => { window.clearTimeout(popupTimeout); popup.hidden = true; }, { signal: events.signal });
    instances.set(section, () => {
      events.abort();
      if (requestController) requestController.abort();
      window.clearInterval(interval); window.clearInterval(popupInterval); window.clearTimeout(popupTimeout);
      instances.delete(section);
    });
  }
  function init(root) {
    if (root.matches && root.matches('[data-avanza-section]')) setup(root);
    root.querySelectorAll('[data-avanza-section]').forEach(setup);
  }
  window.AvanzaLandingUnificada = { init };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [section, cleanup] of instances) if (section === event.target || event.target.contains(section)) cleanup();
  });
  window.addEventListener('pagehide', () => { for (const cleanup of Array.from(instances.values())) cleanup(); });
  window.addEventListener('pageshow', () => init(document));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
